<template>
  <div>
    <b-row class="match-height">
      <b-col v-if="$can('read', 'client-dashboard')"> <client-dashboard /></b-col>
      <b-col xl="6" lg="6" md="12" v-if="$can('read', 'dashboard-network-monitoring')"> <provider-status /></b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SalesStatistic from "./components/SalesStatistic.vue";
import ProviderStatus from "./components/ProviderStatus.vue";
import ThirdParty from "./components/3rdPartyCredit.vue";
import ClientDashboard from "./components/ClientDashboard.vue";

export default {
  name: `MainDashboard`,
  components: { SalesStatistic, ProviderStatus, ThirdParty, ClientDashboard },
  computed: {
    ...mapState(["user"]),
  },
  async mounted() {},
  methods: {},
};
</script>
